import { InfiniteData } from '@tanstack/query-core';

import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import type { ContinueWatchingSettings } from './getContinueWatchingSettings';
import { fetchWatchedAssets } from './queryFunctions';
import { createContinueWatchingQueryOptions } from './queryOptions';

export function getContinueWatchingQueryData({ pageSize, referenceId }: { pageSize: number; referenceId: string }) {
  return queryClient.getQueryData<InfiniteData<Awaited<ReturnType<typeof fetchWatchedAssets>>>>(
    queryKeys.continueWatching(referenceId, pageSize),
  );
}

export function invalidateContinueWatching() {
  queryClient.invalidateQueries({ queryKey: ['CONTINUE_WATCHING'] });
}

export function prefetchContinueWatchingQuery({
  pageSize,
  referenceId,
  settings,
}: {
  pageSize: number;
  referenceId: string;
  settings: ContinueWatchingSettings;
}) {
  return queryClient.prefetchInfiniteQuery({
    ...createContinueWatchingQueryOptions({ pageSize, referenceId, settings }),
    initialPageParam: 1,
  });
}
